import React from 'react'
import { Nav, MenuItem, NavDropdown, Button } from 'react-bootstrap'
import { ButtonLink, MenuItemLink, NavItemLink } from 'react-router-bootstrap'
import Icon from '_/shared/components/icon'
import TopTooltip from '_/shared/components/topTooltip'
import getDisplayName from '_/utils/getDisplayName'
import sortTransactionsByDate from '_/utils/sortTransactionsByDate'
import Backdrop from '_/shared/components/backdrop'

/**
 * Record navigation
 */
class RecordNav extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
    onShareToggle: React.PropTypes.func.isRequired,
    children: React.PropTypes.node
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func,
    notify: React.PropTypes.func
  }

  async syncPublic (evt) {
    evt.preventDefault()
    const { store, router } = this.context
    const { property } = this.props

    const pubId = property.get('isPrivate')
      ? property.getIn(['public', 'id'])
      : property.get('id')

    try {
      const prvProp = await store.post(`/records/${pubId}/sync`)
      router.transitionTo('record', {
        id: prvProp.get('id')
      })
    } catch (er) {
      this.setState({
        syncError: er.response.body.error
      })
    }
  }

  async syncAndNew (type) {
    const { store, router } = this.context
    const { property } = this.props
    const pubId = property.get('id')

    try {
      const prvProp = await store.post(`/records/${pubId}/sync`)
      router.transitionTo(type, {
        id: prvProp.get('id'),
        transId: 'new'
      })
    } catch (er) {
      console.error(er)
    }
  }

  async toggleSharing (evt) {
    evt.preventDefault()
    const { store, notify } = this.context
    const { property, onShareToggle } = this.props
    const id = property.get('id')

    try {
      await store.post(`/records/${id}/toggleSharing`)
      onShareToggle()
    } catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  exportData (evt) {
    evt.preventDefault()
    const { store } = this.context
    const { property, account } = this.props
    store.download(`/records/${property.get('id')}/csv?sid=${account.getIn(['group','id'])}`)
  }

  renderSharing () {
    const { property } = this.props
    const isUnsharable= property.get('unsharable')

    return (
      <small>
        Sharing:&nbsp;
        {isUnsharable &&
          <TopTooltip content="This record can't be shared">
            <a href="#" onClick={::this.toggleSharing}>Off</a>
          </TopTooltip>
        }
        {!isUnsharable &&
          <TopTooltip content="This record can be shared">
            <a href="#" onClick={::this.toggleSharing}>On</a>
          </TopTooltip>
        }
      </small>
    )
  }

  renderExport (property) {
    return (
      <small>
        <TopTooltip content="Export record data as a CSV">
          <a href="#" onClick={::this.exportData}>Export</a>
        </TopTooltip>
      </small>
    )
  }

  renderRecordActions () {
    const { property } = this.props
    const isPrivate = property.get('isPrivate')
    const hasPrivate = property.get('isPrivate') || property.has('private')

    return (
      <div>
        <small>
          <TopTooltip content="Merge public data with private">
            <a href="" onClick={::this.syncPublic}>
              {hasPrivate && 'Sync data'}
              {!hasPrivate && 'Create private record'}
            </a>
          </TopTooltip>
        </small>
        <span className="text-muted"> . </span>
        {this.renderExport()}
        {isPrivate && <span className="text-muted"> . </span>}
        {isPrivate && this.renderSharing(property)}
      </div>
    )
  }

  renderTransactionTab (type) {
    const { property, account } = this.props
    const { router } = this.context
    const types = type + 's'
    const transactions = property.getIn(['transactions', types])
    const label = this.getTabLabel(type)
    const count = transactions.count()
    const countLbl = count ? ` (${count})` : ''
    const isAdmin = account.get('isAdmin')
    const isPrivate = property.get('isPrivate')
    const isActive = RegExp(types).test(router.getCurrentPathname())

    const sortedTransactions = sortTransactionsByDate(transactions, type)

    return (
      <NavDropdown title={`${label}${countLbl}`} className={isActive && 'active'}>
        {sortedTransactions.map((trans, idx) => (
          <MenuItemLink
            key={idx}
            to={type}
            params={{ id: property.get('id'), transId: trans.get('id') }}>
            {getDisplayName(type, trans)}
          </MenuItemLink>
        ))}
        {(isPrivate || isAdmin)
          ?  <MenuItemLink
              to={type}
              params={{
                id: property.get('id'),
                transId: 'new'
              }}>
              <i className="text-success">
                Add new...
              </i>
            </MenuItemLink>
          : <MenuItem onSelect={this.syncAndNew.bind(this, type)}>
              <i className="text-success">
                Add new...
              </i>
            </MenuItem>
        }
      </NavDropdown>
    )
  }

  getTabLabel (type) {
    const t = {
      sale: 'Sales',
      lease: 'Leases',
      incexp: 'Income & expenses',
      const: 'Construction costs'
    }

    return t[type] || ''
  }

  renderPrivateBtn () {
    const { property } = this.props
    const isPrivate = property.get('isPrivate')
    const privateId = isPrivate
      ? property.get('id')
      : property.getIn(['private', 'id'])

    if (!privateId) {
      return (
        <Button bsStyle="info" disabled>
          <Icon name="fa-lock" /> No private record
        </Button>
      )
    }

    return (
      <ButtonLink
        bsStyle="info"
        className="hotkeys-pub-prv-toggle"
        to="record"
        params={{ id: privateId }}>
        <Icon name="fa-lock" /> Go to private
      </ButtonLink>
    )
  }

  renderPublicBtn () {
    const { property } = this.props
    const isPublic = !property.get('isPrivate')
    const publicId = isPublic
      ? property.get('id')
      : property.getIn(['public', 'id'])

    if (isPublic) {
      return (
        <Button active disabled bsStyle="success">
          <Icon name="fa-building-o" />
        </Button>
      )
    }

    return (
      <ButtonLink
        bsStyle="success"
        className="hotkeys-pub-prv-toggle"
        to="record"
        params={{ id: publicId }}>
        <Icon name="fa-building-o" /> Go to public
      </ButtonLink>
    )
  }

  render() {
    const { property, children, account } = this.props
    const isPrivate = property.get('isPrivate')
    const isAdmin = account.get('isAdmin')
    const isAgRes = account.get('isAgRes')
    const isSfr = account.getIn(['group', 'isSfr'])

    const photoUrl = property.has('photoLink')
      ? this.context.store.getUrl(property.get('photoLink'))
      : null

    const lastUseTM =
      property.getIn(['transactions', 'sales', 0, 'useTM']) ||
      property.getIn(['transactions', 'leases', 0, 'useTM'])
      property.getIn(['transactions', 'incexp', 0, 'useTM'])
      property.getIn(['transactions', 'consts', 0, 'useTM'])

    return (
      <Backdrop url={photoUrl}>
        <div className="pull-right text-right">
          {!isAdmin && !isPrivate && this.renderPrivateBtn()}
          {!isAdmin && isPrivate && this.renderPublicBtn()}
          <br/>
          {!isAdmin && this.renderRecordActions()}
        </div>

        <h3>
          <span className={isPrivate ? 'text-info' : 'text-success'}>
            <Icon name={isPrivate ? 'fa-lock' : 'fa-building-o' }/> {isPrivate ? 'Private' : 'Public'}
          </span> record for {getDisplayName('property', property)}
          {isAdmin && <small>&nbsp;({property.get('pid')})</small>}
        </h3>

        <p className="text-muted">
          <i>
            Property use: {property.get('genUseTM').join(', ')}
            {lastUseTM && `: ${lastUseTM.join(', ')}`}
          </i>
        </p>

        <div className="pull-right">
          {children}
        </div>

        <Nav bsStyle="tabs">
          <NavItemLink to="record" params={{ id: property.get('id') }}>
            Property
          </NavItemLink>
          {this.renderTransactionTab('sale')}
          {!isAgRes && this.renderTransactionTab('lease')}
          {!isSfr && this.renderTransactionTab('incexp')}
          {!isAgRes && this.renderTransactionTab('const')}
          {property.has('pid') && property.has('county') && property.get('state') === 'MN' &&
            <NavItemLink to="record-gis" params={{id: property.get('id')}}>
              View on GIS Map
            </NavItemLink>
          }
        </Nav>
      </Backdrop>
    )
  }
}

export default RecordNav



// WEBPACK FOOTER //
// ./modules/shared/pages/record/recordNav.js